import getAllTags from 'api/v2/repository/getAllTags';
import { useQuery, type UseQueryResult } from 'react-query';
import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';
import type { TagItemType } from 'types/repository.types';

const useGetRepositoryTags = (): UseQueryResult<TagItemType[]> => {
  return useQuery([DocumentsRepositoryCacheKeys.AllTags], getAllTags);
};

export default useGetRepositoryTags;
